import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import './link-button-item.js';
import css_248z from './link-button-collection.scss.js';

const linkButtonsConverter = {
    fromAttribute: (value) => {
        if (!value)
            return [];
        try {
            return JSON.parse(value);
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error parsing linkbuttons:', e, 'Value received:', value);
            return [];
        }
    },
    toAttribute: (value) => JSON.stringify(value),
};
class LinkButtonCollection extends s {
    constructor() {
        super(...arguments);
        this.title = 'Quick Action Links';
        this.headingTag = 'h3';
        this.linkButtons = [];
        this.rtl = false;
    }
    renderHeading() {
        const headingContent = o(this.title);
        switch (this.headingTag) {
            case 'h2':
                return $ `<h2 id="collection-title" class="visually-hidden">${headingContent}</h2>`;
            case 'h4':
                return $ `<h4 id="collection-title" class="visually-hidden">${headingContent}</h4>`;
            default:
                return $ `<h3 id="collection-title" class="visually-hidden">${headingContent}</h3>`;
        }
    }
    renderLinkButton(button) {
        return $ `<link-button-item .label="${button.label}" .href="${button.href}" .target="${button.target || '_self'}" .disabled="${button.disabled || false}" .ariaLabel="${button.ariaLabel || ''}" .isNoFollow="${button.isNoFollow || false}" .rtl="${this.rtl || isRTL()}"></link-button-item>`;
    }
    render() {
        const direction = this.rtl || isRTL() ? 'rtl' : 'ltr';
        const containerId = this.id || undefined;
        return $ `<div id="${l(containerId)}" class="link-button-collection" role="group" aria-labelledby="collection-title" dir="${direction}">${this.renderHeading()} ${this.linkButtons.map(button => this.renderLinkButton(button))}</div>`;
    }
}
LinkButtonCollection.styles = css_248z;
__decorate([
    e({ type: String })
], LinkButtonCollection.prototype, "title", void 0);
__decorate([
    e({ attribute: 'heading-tag', type: String })
], LinkButtonCollection.prototype, "headingTag", void 0);
__decorate([
    e({ attribute: 'linkbuttons', converter: linkButtonsConverter })
], LinkButtonCollection.prototype, "linkButtons", void 0);
__decorate([
    e({ type: Boolean })
], LinkButtonCollection.prototype, "rtl", void 0);
customElements.define('link-button-collection', LinkButtonCollection);

export { LinkButtonCollection };
